import { Component, OnInit, Input } from '@angular/core';
import { Flow } from '../obj/Flow';
import { FlowManagementService } from '../services/flow-management.service';
import { WindowRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-flow-solution',
    templateUrl: './flow-solution.component.html',
    styleUrls: ['./flow-solution.component.css'],
    standalone: false
})
export class FlowSolutionComponent implements OnInit {

  constructor(
    private flowManagementService: FlowManagementService,
    public windowRef: WindowRef
  ) {

  }

  solutionId: string;
  error: string;
  @Input() flows: Flow[];

  ngOnInit() {
  }


  public makeSolutionAware() {

    let names = this.flows.filter(f=>!f.solution).map(f=>f.flowName);

    let pSolution = this.flowManagementService.makeFlowSolutionAware(this.flowManagementService.currentEnvironment, names, this.solutionId).toPromise();


    pSolution.then((response)=>{
      if (response == null) {
        // error
        return;
      }
      //alert('done!');
    }, (error) => {

      this.error = error;

    })

  }

  public onClose(): void {
    this.windowRef.close();
  }


}
